import script from "./MenuLateral.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuLateral.vue?vue&type=script&setup=true&lang=js"

import "./MenuLateral.vue?vue&type=style&index=0&id=14a05733&lang=css"

const __exports__ = script;

export default __exports__